/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';
import type { FilterNode } from './FilterNode';
import {
    FilterNodeFromJSON,
    FilterNodeFromJSONTyped,
    FilterNodeToJSON,
} from './FilterNode';

/**
 * 
 * @export
 * @interface TableFilter
 */
export interface TableFilter {
    /**
     * 
     * @type {string}
     * @memberof TableFilter
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TableFilter
     */
    label?: string;
    /**
     * 
     * @type {Command}
     * @memberof TableFilter
     */
    deleteCommand?: Command;
    /**
     * 
     * @type {string}
     * @memberof TableFilter
     */
    expression?: string;
    /**
     * 
     * @type {FilterNode}
     * @memberof TableFilter
     */
    root?: FilterNode;
    /**
     * 
     * @type {Command}
     * @memberof TableFilter
     */
    saveUpdateCommand?: Command;
    /**
     * 
     * @type {boolean}
     * @memberof TableFilter
     */
    expertMode: boolean;
}

/**
 * Check if a given object implements the TableFilter interface.
 */
export function instanceOfTableFilter(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "expertMode" in value;

    return isInstance;
}

export function TableFilterFromJSON(json: any): TableFilter {
    return TableFilterFromJSONTyped(json, false);
}

export function TableFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'deleteCommand': !exists(json, 'deleteCommand') ? undefined : CommandFromJSON(json['deleteCommand']),
        'expression': !exists(json, 'expression') ? undefined : json['expression'],
        'root': !exists(json, 'root') ? undefined : FilterNodeFromJSON(json['root']),
        'saveUpdateCommand': !exists(json, 'saveUpdateCommand') ? undefined : CommandFromJSON(json['saveUpdateCommand']),
        'expertMode': json['expertMode'],
    };
}

export function TableFilterToJSON(value?: TableFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'deleteCommand': CommandToJSON(value.deleteCommand),
        'expression': value.expression,
        'root': FilterNodeToJSON(value.root),
        'saveUpdateCommand': CommandToJSON(value.saveUpdateCommand),
        'expertMode': value.expertMode,
    };
}

